function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import { defineComponent, $prefix, $props, $setup } from "@opentiny/vue-common";
import PcTemplate from "./pc.js";
import MobileFirstTemplate from "./mobile-first.js";
import "@opentiny/vue-theme/dropdown/index.css";
var template = function template2(mode) {
  if ("pc" === (process.env.TINY_MODE || mode)) {
    return PcTemplate;
  }
  if ("mobile-first" === (process.env.TINY_MODE || mode)) {
    return MobileFirstTemplate;
  }
  return PcTemplate;
};
var Dropdown = defineComponent({
  name: $prefix + "Dropdown",
  componentName: "TinyDropdown",
  props: _extends({}, $props, {
    modelValue: [String, Number],
    type: String,
    trigger: {
      type: String,
      default: "hover"
      // 此处aui默认更改为 click
    },
    size: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    splitButton: Boolean,
    singleButton: {
      type: Boolean,
      default: false
    },
    showTimeout: {
      type: Number,
      default: 250
    },
    hideTimeout: {
      type: Number,
      default: 150
    },
    hideOnClick: {
      type: Boolean,
      default: true
    },
    tabindex: {
      type: Number,
      default: 0
    },
    border: {
      type: Boolean,
      default: false
    },
    round: {
      type: Boolean,
      default: false
    },
    showIcon: {
      type: Boolean,
      default: true
    },
    showSelfIcon: {
      type: Boolean,
      default: false
    },
    menuOptions: {
      type: Object,
      default: function _default() {
        return {
          options: [],
          textField: "label",
          popperClass: "",
          placement: "bottom-end"
        };
      }
    },
    title: {
      type: String,
      default: "下拉菜单"
    },
    inheritWidth: {
      type: Boolean,
      default: false
    }
  }),
  setup: function setup(props, context) {
    return $setup({
      props,
      context,
      template
    });
  }
});
var version = "2.10.1";
Dropdown.install = function(Vue) {
  Vue.component(Dropdown.name, Dropdown);
};
Dropdown.version = version;
export {
  Dropdown as default
};
